import React from 'react';
import { trackEvent } from '@raisin/events-tracking';
import { getDistributor } from '@raisin/cp-utils';
import {
  CUSTOMER_PORTAL_COMMON_EVENT_PROPERTIES,
  CUSTOMER_PORTAL_COMPONENT,
} from '../../constants';
import { CustomerPortalEvent } from '../../types';
import { getAuthValue, guardDistributorValue } from '../../utils';

export type OnMediaTileCtaClickedParams = {
  isLoggedIn: boolean;
  pageUrl: string;
  targetUrl: string;
  type: 'primary_CTA' | 'secondary_CTA';
  event: React.MouseEvent<HTMLAnchorElement, MouseEvent>;
};

const createMediaTileCtaClickedEvent = ({
  type,
  targetUrl,
  pageUrl,
  isLoggedIn,
}: OnMediaTileCtaClickedParams): CustomerPortalEvent => ({
  ...CUSTOMER_PORTAL_COMMON_EVENT_PROPERTIES,
  component: CUSTOMER_PORTAL_COMPONENT.MEDIA_TILE,
  context: 'category-management-products',
  eventName: 'CTA_clicked',
  object: 'CTA',
  action: 'clicked',
  customerGroup: guardDistributorValue(getDistributor()),
  customAttribute1: getAuthValue(isLoggedIn),
  customAttribute2: pageUrl,
  customAttribute3: targetUrl,
  customAttribute4: type,
});

export const onMediaTileCtaClicked = (params: OnMediaTileCtaClickedParams) =>
  trackEvent(createMediaTileCtaClickedEvent(params), true, true, params.targetUrl, params.event);
